import { M8ProdStackDTO } from 'services/production/types';
import { normalizeM8DateString } from 'services/production/utils/normalizeM8DateString';
import { ProdStackInfo, TDashboardProdStackInfo } from 'types/state';
import { isLessThanToday } from 'utils/dateUtils';

export const normalizeM8ProdStackDTO = (info: M8ProdStackDTO) => ({
  toDashboardProdStackInfo(): TDashboardProdStackInfo {
    const expirationDate = undefined;

    const expired = expirationDate ? isLessThanToday(expirationDate) : false;

    return {
      expirationDate: expirationDate,
      url: info.adress || '',
      dnsName: '',
      expired,
    };
  },

  toProdStackInfo(): ProdStackInfo {
    const licenseDue = info.licenseEndDate
      ? normalizeM8DateString(info.licenseEndDate).toDate().toISOString()
      : null;

    const trialDue = info.trialEndDate
      ? normalizeM8DateString(info.trialEndDate).toDate().toISOString()
      : null;

    return {
      id: info.id,
      subdomain: null,
      originURL: info.adress,
      loginURL: info.linkLogin,
      loginHash: info.firstHash,
      category: info.stackType,
      updatedOn: info.updatedOn,
      licenseDue,
      trialDue,
      licensesCount: info.activities,
      firstLogin: info.firstLogin,
    };
  },
});
